// Utilitários para formatação de dados

export const formatCPF = (cpf: string): string => {
  const cleaned = cpf.replace(/\D/g, "");
  return cleaned
    .replace(/(\d{3})(\d)/, "$1.$2")
    .replace(/(\d{3})(\d)/, "$1.$2")
    .replace(/(\d{3})(\d{1,2})/, "$1-$2")
    .replace(/(-\d{2})\d+?$/, "$1");
};

export const formatCNPJ = (cnpj: string): string => {
  const cleaned = cnpj.replace(/\D/g, "");
  return cleaned
    .replace(/(\d{2})(\d)/, "$1.$2")
    .replace(/(\d{3})(\d)/, "$1.$2")
    .replace(/(\d{3})(\d)/, "$1/$2")
    .replace(/(\d{4})(\d{1,2})/, "$1-$2")
    .replace(/(-\d{2})\d+?$/, "$1");
};

export const formatTelefone = (telefone: string): string => {
  const cleaned = telefone.replace(/\D/g, "");
  if (cleaned.length === 11) {
    return cleaned.replace(/(\d{2})(\d{5})(\d{4})/, "($1) $2-$3");
  }
  if (cleaned.length === 10) {
    return cleaned.replace(/(\d{2})(\d{4})(\d{4})/, "($1) $2-$3");
  }
  return telefone;
};

export const formatCurrency = (value: number): string => {
  return new Intl.NumberFormat("pt-BR", {
    style: "currency",
    currency: "BRL",
  }).format(value);
};

export const parseCurrency = (value: string): number => {
  const cleaned = value.replace(/[^\d,]/g, "").replace(",", ".");
  return parseFloat(cleaned) || 0;
};

/**
 * Formata uma data em pt-BR sem sofrer deslocamento de fuso horário.
 *
 * Datas puras no formato "yyyy-MM-dd" seriam interpretadas por `new Date()`
 * como meia-noite UTC e, ao converter para o horário de Brasília (UTC-3),
 * voltariam um dia (ex.: 2026-07-31 vira 30/07/2026). Para evitar isso,
 * fixamos o horário ao meio-dia local antes de formatar.
 */
export const formatDateBR = (date?: Date | string | null): string => {
  if (!date) return "-";
  let d: Date;
  if (typeof date === "string") {
    // Extrai o trecho yyyy-MM-dd do início da string (cobre "2026-07-31" e também
    // ISO com hora/UTC como "2026-07-31T00:00:00Z") e fixa o horário ao meio-dia
    // LOCAL, evitando o deslocamento de -1 dia causado pela conversão de fuso.
    const m = date.match(/^(\d{4})-(\d{2})-(\d{2})/);
    d = m ? new Date(`${m[1]}-${m[2]}-${m[3]}T12:00:00`) : new Date(date);
  } else {
    d = date;
  }
  if (isNaN(d.getTime())) return "-";
  return d.toLocaleDateString("pt-BR");
};

export const formatDate = (date: Date | string): string => {
  return formatDateBR(date);
};

/**
 * Monta o período do evento a partir das datas de início e fim.
 * Retorna null quando não há data de início.
 */
export const formatPeriodoEvento = (
  dataInicio?: string | null,
  dataFim?: string | null,
): string | null => {
  if (!dataInicio) return null;
  const inicio = formatDateBR(dataInicio);
  if (dataFim && dataFim !== dataInicio) {
    return `${inicio} a ${formatDateBR(dataFim)}`;
  }
  return inicio;
};

export const formatCodigoOrcamento = (codigoSequencial: number): string => {
  const codigo = codigoSequencial.toString().padStart(4, "0");
  return `ORC ${codigo}`;
};

export const formatDateTime = (date: Date | string): string => {
  const d = typeof date === "string" ? new Date(date) : date;
  return d.toLocaleString("pt-BR");
};
